export const MAXIMUM_AMOUNT_OF_SELECTED_VARIANTS = 100;
